import React, { useState } from 'react';
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from '../Utility/Repo';

const FileDownload = ({ apiToken, versioneServizioId, sovrascrivi, reload }) => {
  const [isLoading, setIsLoading] = useState(false); // Stato per gestire il loader

  const handleDownload = async () => {
    if (!versioneServizioId || !sovrascrivi) {
      console.error('ID e sovrascrivi devono essere forniti');
      return;
    }

    setIsLoading(true); // Mostra il loader

    try {
      await Repo.downloadGraduatoria(apiToken, versioneServizioId, sovrascrivi); // Aspetta che il download sia completo

      if (reload) {
        // window.location.reload(); // Decommenta per ricaricare la pagina se necessario
      }
    } catch (error) {
      console.error('Errore durante il download:', error);
    } finally {
      setIsLoading(false); // Nascondi il loader
    }
  };



return (
  <div>
    {/* Bottone con stato disabilitato durante il download */}
    <button 
      type="button" 
      className={`btn btn-outline-white p-2 w-100 ${isLoading ? 'btn-xs border border-warning' : ''}`}
      onClick={handleDownload}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <svg className="icon icon-white mr-1">
            <use href={`${iconSprite}#it-file`} />
          </svg>
          <span className="align-middle">Download in corso...</span>
          <span class="progress">
        <span class="pprogress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar" style={{ width: '100%' }} ></span>
      </span>
        </>
      ) : (
        <>
          <svg className="icon icon-white mr-1">
            <use href={`${iconSprite}#it-file`} />
          </svg>
          <span className="align-middle">Scarica Excel</span>
        </>
      )}
 </button>

   
  </div>
);
};
export default FileDownload;